import * as types from './thematicsActionTypes';
import firebaseApp from './../../utils/firebase/firebase';
import { push } from 'react-router-redux';
import * as constantArticle from './../../conf/constantArticle';

import {getAllArticleReactionsByThematic} from './../Article/articleActions';

import SingletonLibrary from '../../library/SingletonLibrary';


export const setThematics = ( thematics ) => {
    return {
        type: types.SET_THEMATICS_LIST,
        thematics: thematics
    };
};

export const setThematicsFailed = (errorMessage, errorCode) => {
    return {
        type: types.SET_THEMATICS_FAILED,
        errorCode,
        errorMessage
    }
}

export const getArticlesByThematicStart = () => {
    return {
        type: types.RETRIEVE_THEMATIC_ARTICLE_LIST_START
    }
}

export const getArticlesByThematicSuccess = (thematicSlug, articleList) => {
    return {
        type: types.RETRIEVE_THEMATIC_ARTICLE_LIST_SUCCESS,
        currentThematic: thematicSlug,
        thematicArticleList: articleList
    }
}

export const getArticlesByThematicFail = (errorMessage, errorCode) => {
    return {
        type: types.RETRIEVE_THEMATIC_ARTICLE_LIST_FAIL,
        errorCode,
        errorMessage
    }
}

export function getArticlesByThematic(thematicSlug, redirect = true){
    return (dispatch, getState) => {

        //firebaseApp.auth().currentUser.getIdToken()
        //    .then(function(fbIdToken) {
                   
                dispatch(getArticlesByThematicStart());
                const isUserSignedIn = getState().auth.isUserSignedIn;
                
                SingletonLibrary
                    .getAxiosInstance
                    .get('/thematic/'+thematicSlug, { headers:{/*'fbkm-access-token':fbIdToken*/}})
                    .then((result) => {
                        const response = ( result.error !== true && typeof result.data.response !== 'undefined' )?  
                            result.data.response : null ;
                        
                        if( response !== null ) {
                            let listArticles = [];    
                            if(response.articles.length>0){   
                                for(const articleIndex in response.articles){
                                    const articleRawData = response.articles[articleIndex];
                                    
                                    //let minimalArticleData = {};
                                    if(articleRawData.hasOwnProperty('_source')){
                                        const sourceData = articleRawData._source;
                                        let mainBlock = {'content':'', 'author':''};
                                        
                                        // loop through all blocks to find the main image's article
                                        //Object.entries(sourceData.blocks).forEach(([blockIndex, blockData]) => {
                                        Object.entries(sourceData.blocks).some(([blockIndex, blockData]) => {
                                            if(blockData.hasOwnProperty('type') && parseInt(blockData.type, 10)===constantArticle.DOCUMENT_TYPE_IMAGE){
                                                if(blockData.hasOwnProperty('content') && blockData.content!==''){
                                                    mainBlock.content = blockData.content;
                                                    return true; // return true acts like a "break" in a loop
                                                }
                                            }
                                            return false;
                                        });
                                        
                                        
                                        const minimalArticleData = {'id':sourceData.id,
                                                                'document_type':sourceData.document_type,
                                                                'thematic':sourceData.kids_thematic,
                                                                'title':sourceData.title,
                                                                'slug':sourceData.uri,
                                                                'main_block': mainBlock
                                        }

                                        // add minimal article data into array
                                        listArticles.push(minimalArticleData);
                                    }    
                                    
                                }

                            }
                            dispatch(getAllArticleReactionsByThematic(thematicSlug));
                            dispatch(getArticlesByThematicSuccess(thematicSlug, listArticles));
                                
                            // redirect to thematic page
                            if(redirect && isUserSignedIn)
                            {
                              const thematicURL = '/thematic/'+thematicSlug;
                              dispatch(push(thematicURL));
                            }
                            else if (redirect)
                            {
                              const thematicURL = '/discover/thematic/'+thematicSlug;
                              dispatch(push(thematicURL));
                            }                                    
                        }
                    })
                    .catch((e) => {
                        const errorCode = ( typeof e.response !== 'undefined' && e.response.status ) || 0;
                        const errorMessage = ( typeof e.response !== 'undefined' && e.response.statusText ) || 'Erreur inattendue';
                        
                        dispatch(getArticlesByThematicFail(errorMessage, errorCode)); 
                    });
                    
            //});
    }
    
}



// WEBPACK FOOTER //
// ./src/components/Thematics/thematicsActions.js